// extracted by mini-css-extract-plugin
export default {"root":"HeroHeader_root__CK1u0","inner":"HeroHeader_inner__VH9ok","boxSearch":"HeroHeader_boxSearch__3PBsH","boxSearchInner":"HeroHeader_boxSearchInner__SwtiD"};